// extracted by mini-css-extract-plugin
export default {"attribute-text":"attribute-text_ECo3JrOd","attribute-dagger":"attribute-dagger_LZ9XTl_r"};